// import { useAppSelector } from '../../../store/hooks'

export const MainFullPreloader = () => {
    return (
        <div className="app_full_main_loader_container">
            <div className="main-full-preloader"></div>
        </div>
    )
}

export const TopBarPreloader = () => {
  return <></>
    // const runningMainAjaxRequests = useAppSelector(
    //   (state: any) => state.main.runningRequests
    // )
    // const runningSecurityAjaxRequests = useAppSelector(
    //     (state: any) => state.security.authRunningRequests
    // )
    // return Object.keys({
    //     // ...runningMainAjaxRequests,
    //     ...runningSecurityAjaxRequests,
    // }).length > 0 ? (
    //     <div className="top-main-loader top-main-loader--active"></div>
    // ) : (
    //     <></>
    // )
}
